import About from "../../views/AboutUs";
import Academy from "../../views/Academy";
import Contact from "../../views/Contact";
import Error from "../../views/Errors/Error";
import Blog from "../../views/Blog";
import Landing from "../../views/Landing/Landing";
import Student from "../../views/Student";
import {
  aboutPath,
  academyPath,
  studentPath,
  contactPath,
  // booksPath,
  // eachstudentPath,
  forgotPasswordPath,
  landingPath,
  loginPath,
  qiraatPath,
  waitListPath,
  blogPath,
  quranPath,
  learningToolsPath,
  // changePasswordPath,
  signUpPath,
  eachInstrutor,
  eachstudentPath,
} from "./path";
import Affiliate from "../../views/Affiliate";
import WaitList from "../../views/WaitList";
import Login from "../../views/Login";
import ForgetPassword from "../../views/ForgetPassword";
import LearningTools from "../../views/LearningTools";
import Qirahat from "../../views/Qirahat";
import Quran from "../../views/Quran";
import Instructor from "../../views/Instrustor";
import SignUp from "../../views/SignUp";

export const Allroutes = [
  { path: landingPath, component: Landing },
  { path: academyPath, component: Academy },
  { path: quranPath, component: Affiliate },
  { path: signUpPath, component: SignUp },
  { path: aboutPath, component: About },
  { path: contactPath, component: Contact },
  { path: blogPath, component: Blog },
  { path: waitListPath, component: WaitList },
  { path: loginPath, component: Login },
  { path: forgotPasswordPath, component: ForgetPassword },
  { path: eachstudentPath, component: Affiliate },
  { path: learningToolsPath, component: LearningTools },
  { path: qiraatPath, component: Qirahat },
  { path: quranPath, component: Quran },
  { path: eachInstrutor, component: Instructor },
  { path: studentPath, component: Student },
  { path: "*", component: Error },
];
// Add other routes here...
